import type { ServiceResponseCallback } from 'owa-analytics-types';
import type { InternalRequestOptions } from 'owa-service/lib/RequestOptions';
import type { MailboxInfo } from 'owa-client-types';

var serviceResponseCallbackNumber = 0;
var createServiceResponseCallbacks: {
    [key: number]: ServiceResponseCallback;
} = {};

// this returns a function that will unregister it
export function registerCreateServiceResponseCallback(
    callback: ServiceResponseCallback
): () => void {
    const id = serviceResponseCallbackNumber++;
    createServiceResponseCallbacks[id] = callback;

    return () => {
        delete createServiceResponseCallbacks[id];
    };
}

export function callResponseCallbacks(
    requestOptions: Promise<InternalRequestOptions>,
    promise: Promise<Response>,
    actionName: string,
    url: string,
    mailboxInfo: MailboxInfo | undefined
): void {
    for (const cb of Object.values<ServiceResponseCallback>(createServiceResponseCallbacks)) {
        cb(
            url.includes('ows/') ? 'OWSPrime' : 'Other',
            promise,
            actionName || 'OWS',
            url,
            0,
            mailboxInfo,
            requestOptions
        );
    }
}
